import { Reveal } from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/content";

const VideoCard = ({ video, index }) => (
  <Reveal delay={index * 0.08}>
    <div
      data-testid={`testimonial-video-${video.id}`}
      className="overflow-hidden rounded-xl border border-slate-100 bg-navy-ink shadow-sm transition-shadow hover:shadow-xl"
    >
      <div className="aspect-video w-full">
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${video.id}?rel=0`}
          title={video.title}
          loading="lazy"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="h-full w-full border-0"
        />
      </div>
    </div>
  </Reveal>
);

export const Testimonials = () => (
  <section
    id="testimonials"
    data-testid="testimonials-section"
    className="border-t border-slate-100 bg-white py-24 md:py-32"
  >
    <div className="mx-auto w-full max-w-7xl px-6 md:px-12">
      <Reveal>
        <h2 className="font-display text-4xl font-bold uppercase leading-[1.05] tracking-tight text-ink sm:text-5xl">
          {TESTIMONIALS.heading}
        </h2>
      </Reveal>

      {TESTIMONIALS.categories.map((category) => (
        <div
          key={category.slug}
          data-testid={`testimonials-${category.slug}`}
          className="mt-14 first:mt-12"
        >
          <Reveal>
            <div className="flex items-center gap-4">
              <span className="h-px w-10 bg-navy" aria-hidden="true" />
              <h3 className="font-display text-xl font-semibold uppercase tracking-tight text-ink sm:text-2xl">
                {category.heading}
              </h3>
            </div>
          </Reveal>
          <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {category.videos.map((video, i) => (
              <VideoCard key={video.id} video={video} index={i} />
            ))}
          </div>
        </div>
      ))}
    </div>
  </section>
);
